module.exports = __webpack_public_path__ + "static/4-4ee2d38c524b4490d8d7e520dcc5f58a.jpg";